import React from 'react';
import App from 'next/app';
import { ChakraProvider } from '@chakra-ui/react';
import { defaultTheme } from '../ui/theme';
const defaults = {
    theme: defaultTheme,
    Providers: React.Fragment,
};
export function createChakraNextApp({ theme = defaultTheme, Providers = React.Fragment, } = defaults) {
    return class ChakraNextApp extends App {
        render() {
            const { Component, pageProps } = this.props;
            return (<ChakraProvider theme={theme} resetCSS>
          <Providers>
            <Component {...pageProps}/>
          </Providers>
        </ChakraProvider>);
        }
    };
}
